export const LayoutClasses = {
  main: 'layout',
  content: 'layout-content',
  header: 'layout-header',
  footer: 'layout-footer',
};
